function textToLink(text) {
	var result = text.split('><').map(line => oneLineTextToLink(line)).join('><');
	return result;
}

function oneLineTextToLink(text) {
	const defaultLabel = "اضغط هنا";
	if (text.indexOf("href=") != -1) {
		return text;
	}

	var exp = /(\bhttps?:\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
	var text1 = text.replace(exp, `<a href='$1'>${defaultLabel}</a>`);
	var exp2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
	var result = text1.replace(exp2, `$1<a target="_blank" href="http://$2">${defaultLabel}</a>`);
	return result;
}

export { textToLink };
